import { PlusCircleIcon } from "@heroicons/react/24/solid";
const ExecuteButton = ({
  buttonText = "",
  onClick,
  className = "",
  disabled = false,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      type="button"
      className={
        (disabled
          ? "cursor-not-allowed border text-secondary opacity-50 border-secondary "
          : "text-secondary border-secondary") +
        `${className} flex items-center place-content-center hover:scale-90 transition duration-500 bg-tranparent  border-secondary shadow-md hover:bg-secondary text-secondary group relative py-1 px-3 border text-xs font-medium rounded-full hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary focus:ring-opacity-70`
      }
    >
      <PlusCircleIcon className="h-4 w-4 mr-2" />
      <p className="font-semibold"> {buttonText}</p>
    </button>
  );
};
export default ExecuteButton;
